module.exports = __webpack_public_path__ + "static/media/walker.5ea1a2f1.svg";